(function () {
  'use strict';

  var style = document.createElement('style');
  style.textContent =
    '.tee-photo-error { display: none !important; }' +
    '.tee-photo-preview-history__image { border: none !important; padding: 0 !important; background: transparent !important; box-shadow: none !important; }' +
    '.tee-photo-head { padding-top: 22px; }' +
    '.tee-photo-preview-history[data-bb-label] { position: relative; padding-top: 22px; }' +
    '.tee-photo-label[data-bb-label]::before, .tee-photo-preview-history[data-bb-label]::before {' +
      'content: attr(data-bb-label);' +
      'position: absolute;' +
      'font-weight: 700;' +
      'font-size: 12px;' +
      'letter-spacing: 0.3px;' +
      'white-space: nowrap;' +
      'pointer-events: none;' +
      'z-index: 2;' +
    '}' +
    '.tee-photo-label[data-bb-label]::before { bottom: 100%; left: 0; margin-bottom: 4px; color: #c88a00; }' +
    '.tee-photo-preview-history[data-bb-label]::before { top: 2px; left: 3px; color: #000; }';
  document.head.appendChild(style);

  var PLACEHOLDER = 'CUSTOM';
  var LOADING_DURATION = 30;
  var _loadingTimers = {};
  var LOADING_TEXTS_BY_LANG = {
    de: [
      'Dein Kunstwerk entsteht gerade...',
      'Etwas Besonderes wird für dich gemacht...',
      'Dein persönliches Design wird erstellt...',
      'Die letzten Pinselstriche werden gesetzt...'
    ],
    fr: [
      'Votre œuvre d\'art est en cours...',
      'Quelque chose de spécial se prépare...',
      'Votre design personnalisé est en cours de création...',
      'Les dernières touches de pinceau sont appliquées...'
    ],
    en: [
      'Your artwork is being created...',
      'Something special is being made for you...',
      'Your personal design is on its way...',
      'The final brushstrokes are being applied...'
    ]
  };

  var VALIDATION_MSGS = {
    de: 'Bitte gib zuerst einen Namen ein.',
    fr: 'Veuillez d\'abord entrer un nom.',
    en: 'Please enter a name first.'
  };

  var GUIDANCE_BOX_STYLE = 'margin:0 0 14px;padding:14px 16px;background:#fff9e9;border:1px solid #f2d27a;border-radius:10px;font-size:14px;line-height:1.5;color:#3a3a3a;';

  var GUIDANCE_HTML_DE =
    '<div id="bb-ai-guidance" style="' + GUIDANCE_BOX_STYLE + '">' +
      '<div style="font-weight:700;font-size:15px;margin-bottom:6px;">So entsteht dein Puzzle in &lt; 60 Sekunden</div>' +
      '<div style="margin-bottom:8px;">Aus deinem Lieblingsfoto entsteht ein handgemalt wirkendes Kunstwerk.</div>' +
      '<div style="font-size:13px;color:#5a5a5a;border-top:1px dashed #f2d27a;padding-top:8px;">Du siehst sofort eine Vorschau und kannst das Bild kostenlos neu erstellen lassen, sollte etwas nicht passen.</div>' +
    '</div>';

  var GUIDANCE_SUCCESS_INNER_DE =
    '<div style="font-weight:700;font-size:15px;margin-bottom:6px;">Super – dein Bild ist fertig!</div>' +
    '<div style="margin-bottom:8px;">Alles richtig gemacht. Schau dir die Vorschau in Ruhe an.</div>' +
    '<div style="font-size:13px;color:#5a5a5a;border-top:1px dashed #f2d27a;padding-top:8px;">Du möchtest eine andere Version? Klicke unten auf <strong>„Anderes Bild wählen"</strong> – immer kostenlos.</div>';

  function markGuidanceSuccess() {
    var guidance = document.getElementById('bb-ai-guidance');
    if (!guidance) return;
    if (guidance.dataset.bbPostUpload === '1') return;
    guidance.dataset.bbPostUpload = '1';
    guidance.innerHTML = GUIDANCE_SUCCESS_INNER_DE;
  }

  var STEP_LABEL_STYLE = 'display:block;margin:18px 0 8px;padding:6px 10px;font-weight:700;font-size:13px;color:#8a6d1f;background:#fff9e9;border-left:3px solid #f2d27a;border-radius:4px;letter-spacing:0.2px;';

  function makeStepLabel(n, text) {
    return '<div class="bb-step-label" style="' + STEP_LABEL_STYLE + '">Schritt ' + n + ' · ' + text + '</div>';
  }

  function hasStepLabel(el) {
    return el && el.classList && el.classList.contains('bb-step-label');
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  }

  function injectGuidance() {
    if (getLang() !== 'de') return;
    // Guidance box copy and step labels are puzzle-flow specific
    // (Titelzeile / Namen / Lieblingsfoto), so only inject on products
    // that actually carry the .ai-inject-field — i.e. the AI puzzle
    // products. Other Teeinblue products (Bestecke etc.) load this
    // script for the loading overlay only and shouldn't see the
    // puzzle copy.
    if (!hasPromptField()) return;
    if (!document.getElementById('bb-ai-guidance')) {
      var anchor = document.querySelector('#teeFormInputs') || document.querySelector('.ai-inject-field');
      if (anchor) anchor.insertAdjacentHTML('beforebegin', GUIDANCE_HTML_DE);
    }

    var step = 1;

    var nameField = document.querySelector('.ai-inject-field');
    var nameWrapper = nameField ? (nameField.closest('.tee-field') || nameField) : null;

    if (nameWrapper) {
      var walker = document.createTreeWalker(nameWrapper, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf('Wird nach Foto-Upload sichtbar') !== -1) {
          node.nodeValue = node.nodeValue.replace('Wird nach Foto-Upload sichtbar', 'Nach Foto-Upload sichtbar');
        }
      }
    }

    var titleField = null;
    var candidates = document.querySelectorAll('#teeFormInputs .tee-field');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c === nameWrapper) break;
      if (!isVisible(c)) continue;
      if (c.querySelector('select')) { titleField = c; break; }
    }
    if (titleField) {
      if (!hasStepLabel(titleField.previousElementSibling)) {
        titleField.insertAdjacentHTML('beforebegin', makeStepLabel(step, 'Titelzeile wählen'));
      }
      step++;
    }
    if (nameWrapper && !hasStepLabel(nameWrapper.previousElementSibling)) {
      nameWrapper.insertAdjacentHTML('beforebegin', makeStepLabel(step, 'Namen des Kindes eingeben'));
    }
    if (nameWrapper) step++;

    var photoInput = document.querySelector('#teeFormInputs input[type="file"]');
    var photoWrapper = photoInput ? photoInput.closest('.tee-field') : null;
    if (photoWrapper && !hasStepLabel(photoWrapper.previousElementSibling)) {
      photoWrapper.insertAdjacentHTML('beforebegin', makeStepLabel(step, 'Lieblingsfoto hochladen'));
    }

    if (document.querySelector('.tee-photo-preview-history__image')) {
      markGuidanceSuccess();
    }

    labelVersions();
  }

  function labelVersions() {
    var history = document.querySelectorAll('.tee-photo-preview-history__image');
    if (history.length === 0) return;

    var currentCard = document.querySelector('.tee-photo-label');
    if (currentCard) currentCard.setAttribute('data-bb-label', 'Aktuelle Version');

    var historyContainer = document.querySelector('.tee-photo-preview-history');
    if (historyContainer) historyContainer.setAttribute('data-bb-label', 'Vorherige Versionen');
  }

  var _guidanceInterval = setInterval(injectGuidance, 500);
  setTimeout(function () {
    clearInterval(_guidanceInterval);
    var target = document.querySelector('#teeFormInputs') || document.querySelector('.tee-form');
    if (!target) return;
    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(injectGuidance, 100);
    }).observe(target, { childList: true, subtree: true });
  }, 30000);

  function getLang() {
    return (document.documentElement.lang || 'de').split('-')[0].toLowerCase();
  }

  function getLoadingTexts() {
    return LOADING_TEXTS_BY_LANG[getLang()] || LOADING_TEXTS_BY_LANG.de;
  }

  function showValidationError() {
    var wrapper = document.querySelector('.ai-inject-field');
    if (!wrapper) return;
    if (wrapper.querySelector('#bb-validation-msg')) return;

    var msg = VALIDATION_MSGS[getLang()] || VALIDATION_MSGS.de;
    var el = document.createElement('div');
    el.id = 'bb-validation-msg';
    el.textContent = msg;
    el.style.cssText = 'margin-top:6px;padding:6px 10px;background:#fde8e8;color:#c0392b;font-size:13px;border-radius:4px;border:1px solid #f5c6c6;';
    wrapper.appendChild(el);

    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 4000);

    var input = wrapper.querySelector('input');
    if (input) input.focus();
  }

  function hasPromptField() {
    return !!document.querySelector('.ai-inject-field');
  }

  function getPromptValue() {
    var wrapper = document.querySelector('.ai-inject-field');
    if (!wrapper) return '';
    var el = wrapper.querySelector('input');
    return el ? el.value.trim() : '';
  }

  function injectPrompt(formData) {
    var value = getPromptValue();
    if (!value) return;
    var effects = formData.get('effects');
    if (effects) {
      formData.set('effects', effects.split(PLACEHOLDER).join(value));
    }
  }

  function showLoading() {
    if (window.__bbLoadingActive) return;
    if (document.querySelector('#bb-loading')) return;
    var anchor = document.querySelector('#teeFormInputs') || document.querySelector('.tee-form');
    if (!anchor) return;
    window.__bbLoadingActive = true;

    anchor.style.position = 'relative';

    var loader = document.createElement('div');
    loader.id = 'bb-loading';
    loader.style.cssText = 'position:absolute;inset:0;z-index:999;background:rgba(255,255,255,0.95);display:flex;flex-direction:column;align-items:center;justify-content:center;border-radius:8px;';

    var circumference = 2 * Math.PI * 40;

    loader.innerHTML =
      '<div style="position:relative;width:100px;height:100px;margin:0 auto 16px;">' +
        '<svg width="100" height="100" viewBox="0 0 100 100" style="transform:rotate(-90deg);">' +
          '<circle cx="50" cy="50" r="40" fill="none" stroke="#eee" stroke-width="6"/>' +
          '<circle id="bb-progress-ring" cx="50" cy="50" r="40" fill="none" stroke="#000" stroke-width="6" ' +
            'stroke-dasharray="' + circumference + '" stroke-dashoffset="' + circumference + '" ' +
            'stroke-linecap="round" style="transition:stroke-dashoffset 0.5s ease;"/>' +
        '</svg>' +
        '<span id="bb-percent" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:20px;color:#000;">0%</span>' +
      '</div>' +
      '<span id="bb-loading-text" style="display:block;font-weight:500;font-size:14px;color:#333;font-style:italic;min-height:20px;text-align:center;"></span>';

    anchor.appendChild(loader);

    var startTime = Date.now();
    var ring = document.querySelector('#bb-progress-ring');
    var percentEl = document.querySelector('#bb-percent');

    _loadingTimers.percent = setInterval(function () {
      var elapsed = (Date.now() - startTime) / 1000;
      var pct = Math.min(Math.floor((elapsed / LOADING_DURATION) * 100), 99);
      if (percentEl) percentEl.textContent = pct + '%';
      if (ring) {
        var offset = circumference - (pct / 100) * circumference;
        ring.setAttribute('stroke-dashoffset', offset);
      }
    }, 500);

    var texts = getLoadingTexts();
    var textIdx = 0;
    var textEl = loader.querySelector('#bb-loading-text');
    if (textEl) textEl.textContent = texts[0];

    _loadingTimers.text = setInterval(function () {
      textIdx = (textIdx + 1) % texts.length;
      if (textEl) textEl.textContent = texts[textIdx];
    }, 4000);

    // Safety net: async jobs are hidden by the /status poll (below). If that signal is ever
    // missed (error, navigation), don't leave the overlay stuck forever.
    _loadingTimers.safety = setTimeout(hideLoading, 120000);
  }

  function hideLoading() {
    var percentEl = document.querySelector('#bb-percent');
    var ring = document.querySelector('#bb-progress-ring');
    if (percentEl) percentEl.textContent = '100%';
    if (ring) ring.setAttribute('stroke-dashoffset', '0');

    setTimeout(function () {
      if (_loadingTimers.percent) clearInterval(_loadingTimers.percent);
      if (_loadingTimers.text) clearInterval(_loadingTimers.text);
      if (_loadingTimers.safety) clearTimeout(_loadingTimers.safety);
      _loadingTimers = {};

      var loaders = document.querySelectorAll('#bb-loading');
      loaders.forEach(function (l) { l.remove(); });

      window.__bbLoadingActive = false;
      markGuidanceSuccess();
    }, 600);
  }

  // Teeinblue runs the AI effect either SYNCHRONOUSLY (the POST resolves once the image is ready)
  // or ASYNCHRONOUSLY: .../image-filter-effects/async returns a queued job ({id, status:0}) right
  // away, then the client polls .../image-filter-effects/status until the status is terminal
  // (0 = queued, 1 = processing, 2 = done; error_message set on failure). For async jobs we must
  // keep the overlay until the STATUS poll reports done — hiding on the initial POST flashed the
  // overlay away instantly (the bug on the async products, e.g. the rentrée t-shirt).
  function isEffectUrl(u) { return u.indexOf('image-filter-effects') !== -1; }
  function effectStatusTerminal(d) { return !!(d && (d.error_message || (d.status != null && d.status !== 0 && d.status !== 1))); }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');

    // Job start: the FormData POST that kicks off an effect (sync or async).
    if (isEffectUrl(url) && init.body instanceof FormData) {
      if (hasPromptField()) {
        if (!getPromptValue()) {
          showValidationError();
          return Promise.reject(new Error('bb-prompt-injector: name required'));
        }
        injectPrompt(init.body);
      }
      var isAsync = url.indexOf('/async') !== -1;
      showLoading();
      return _fetch.call(this, input, init).then(function (response) {
        if (!isAsync) hideLoading(); // async: the /status poll below hides it when the job finishes
        return response;
      }).catch(function (err) {
        hideLoading();
        throw err;
      });
    }

    // Job end (async): hide when the status poll reports a terminal status or an error.
    if (isEffectUrl(url) && url.indexOf('/status') !== -1) {
      return _fetch.call(this, input, init).then(function (response) {
        response.clone().json().then(function (data) {
          if (effectStatusTerminal(data)) hideLoading();
        }).catch(function (err) {
          // Non-JSON / parse failure: log it and hide the overlay so it can't get stuck.
          console.warn('bb-prompt-injector: could not parse effect status response', err);
          hideLoading();
        });
        return response;
      });
    }

    return _fetch.call(this, input, init);
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._tibUrl = url || '';
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var url = this._tibUrl || '';
    // Job start via XHR (sync or async).
    if (isEffectUrl(url) && body instanceof FormData) {
      if (hasPromptField()) {
        if (!getPromptValue()) {
          showValidationError();
          return;
        }
        injectPrompt(body);
      }
      var isAsync = url.indexOf('/async') !== -1;
      showLoading();
      if (!isAsync) this.addEventListener('loadend', function () { hideLoading(); });
    } else if (isEffectUrl(url) && url.indexOf('/status') !== -1) {
      // Job end (async) via XHR: hide when the status poll reports terminal/error.
      var xhr = this;
      this.addEventListener('loadend', function () {
        try {
          if (effectStatusTerminal(JSON.parse(xhr.responseText))) hideLoading();
        } catch (e) {
          console.warn('bb-prompt-injector: could not parse effect status response', e);
        }
      });
    }
    return _send.apply(this, [body]);
  };
})();
